import React from 'react';
// import withBasedRouter from '@shootsta/with-based-router';
import { ApolloConsumer } from 'react-apollo';
import { UploaderConsumer } from '../../../../Uploader';
import DropZoneComponent from '../components/DropZone';
// import { basePath } from '../../../../../constants';









function DropZone({
  isVisible,
  setFilePickerRef,
  closeDropZone,
  handleDragOut,
  dropZoneRef
}) {
  return (
    <ApolloConsumer>
      {(organisation) =>
      <UploaderConsumer>
          {({ addFileToQueue }) =>
        <DropZoneComponent
          addFileToQueue={addFileToQueue}
          closeDropZone={closeDropZone}
          organisation={organisation}
          filePickerRefCallBack={setFilePickerRef}
          isVisible={isVisible}
          handleDragOut={handleDragOut}
          ref={dropZoneRef} />}


        </UploaderConsumer>}

    </ApolloConsumer>);

}

// export default withBasedRouter(basePath, DropZone);
export default DropZone;